"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = void 0;
var _formsModule = _interopRequireDefault(require("@albelli/arc-3/lib/forms.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CheckBox = _ref => {
  let {
    id,
    className,
    label,
    error,
    value,
    onChange,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_formsModule.default["arc3-form__input-wrapper"], "arc3-full-width", {
      error: !!error
    }, className)
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(_formsModule.default["arc3-checkbox-wrapper"], "arc3-pointer")
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    className: _formsModule.default["arc3-checkbox"],
    id: id,
    type: "checkbox",
    checked: value,
    onChange: onChange,
    value: value
  }, props)), label), /*#__PURE__*/_react.default.createElement("small", {
    className: (0, _classnames.default)(_formsModule.default["arc3-form-message"], "arc3-no-margin")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)({
      error: !!error
    }),
    style: {
      whiteSpace: "pre"
    }
  }, error)));
};
exports.CheckBox = CheckBox;
CheckBox.propTypes = {
  /** HTML option elements */
  error: _propTypes.default.string,
  /** Selected value of the dropdown */
  value: _propTypes.default.any,
  /** Callback for when dropdown value changes */
  onChange: _propTypes.default.func,
  /** Label text for the dropdown */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Mark the dropdown as *required* */
  isRequired: _propTypes.default.bool,
  /** Optional element id */
  id: _propTypes.default.string,
  /** Optional custom CSS classes */
  className: _propTypes.default.string
};